import type { OrderProductOptions } from "../OrderProductOptions.js";
import { ProductOption, productOptionKeyMap } from "../ProductOption.js";
import { isProductOptionUsed } from "./isProductOptionUsed.js";

export function doesOrderProductHaveAnyOption(
	options: OrderProductOptions | undefined,
): options is OrderProductOptions {
	if (options === undefined) {
		return false;
	}

	return Object.values(ProductOption).some((option) => {
		return isProductOptionUsed(option, options[productOptionKeyMap[option]]);
	});
}
